
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock } from "lucide-react";

interface AgendaHeaderProps {
  psychologistId?: string;
}

const AgendaHeader: React.FC<AgendaHeaderProps> = ({ psychologistId }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-blue-500" />
          Agenda Global 24h
        </CardTitle>
        <CardDescription>
          Visualize e configure seus horários. Clique em uma data para ver detalhes ou configurar novos horários. 🌍
          {!psychologistId && (
            <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
              ⚠️ ID do psicólogo não encontrado. Entre em contato com o suporte.
            </div>
          )}
        </CardDescription>
      </CardHeader>
    </Card>
  );
};

export default AgendaHeader;
